module.exports = __webpack_public_path__ + "img/gotfertomi-coussins-4.52629f5f.jpg";